<template>
  <div class="row">
    

    <div class=" col-md-12 modal-body-expense" style="padding: 15px;">
      <div class="row" style="padding: 5px;">
          <div class="col-md-12">
              <div class="alert alert-danger" v-if="errors.length">
                  <strong>Whoops!</strong> There were some problems with your
                  input.<br /><br />
                  <ul>
                      <li v-for="error in errors">{{ error }}</li>
                  </ul>
              </div>

              <div class="row">
                  <div class="col-8">
                      <div class="text-left section-title" style="padding: 5px;">
                          <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                            Collect Shared Payment
                          </span>
                      </div>
                  </div>

              </div>
              <div class="row">
                  <div class="col-xs-6 col-sm-6 col-md-6">
                      <div class="form-group">
                          <label>Debtor:</label>
                          <select class="form-control"
                                  v-model="debtor_id"
                                  v-on:change="onChange">
                              <option v-for="debtor in debtors" :value="debtor.id">
                                  {{ debtor.floor }} - {{ debtor.number }} -
                                  {{ debtor.contact.name }}
                              </option>
                          </select>
                      </div>
                  </div>

                  <div class="col-xs-6 col-sm-6 col-md-6">
                      <div class="form-group">
                          <label>Payment Type:</label>
                          <select @change="
                    paymentTypeChange(additionalExpensePayment.paymentType)
                  "
                                  class="form-control"
                                  v-model="additionalExpensePayment.paymentType">
                              <option :value="1">
                                  Cash
                              </option>
                              <option :value="2">
                                  Cheque
                              </option>
                              <option :value="3">
                                  Bank Order
                              </option>
                          </select>
                      </div>
                  </div>
              </div>

              <div class="row">
                  <div class="col-xs-6 col-sm-6 col-md-6">
                      <div class="form-group">
                          <label>Amount :</label>
                          <input type="text"
                                 class="form-control"
                                 number
                                 v-model="amount" />
                      </div>
                  </div>
                  <div class="col-xs-6 col-sm-6 col-md-6">
                      <div class="form-group">
                          <label>Bank:</label>
                          <input class="form-control"
                                 :disabled="additionalExpensePayment.paymentType == 1"
                                 v-model="additionalExpensePayment.bank" />
                      </div>
                  </div>
              </div>

              <div class="row">
                  <div class="col-xs-6 col-sm-6 col-md-6">
                      <div class="form-group">
                          <label>Reference:</label>
                          <input class="form-control"
                                 :disabled="additionalExpensePayment.paymentType == 1"
                                 v-model="additionalExpensePayment.reference" />
                      </div>
                  </div>

                  <div class="col-xs-6 col-sm-6 col-md-6">
                      <div class="form-group">
                          <label>Paid Date:</label>
                          <date-picker class="form-control"
                                       :format="customFormatter"
                                       v-model="additionalExpensePayment.paidDate" />
                      </div>
                  </div>
              </div>

              <div class="col-md-12" style="padding-left: 0;">
                  <div class="col-md-12" style="padding-left: 0; padding-right: 0;">
                      <table class="table table-condensed" style="border:0;box-shadow:none">
                          <thead class="">
                              <tr>
                                  <th class="no-border text-center col-md-3">
                                      Expense Type
                                  </th>
                                  <th class="no-border text-center col-md-3">
                                      Additional Exp. Fee
                                  </th>
                                  <th class="no-border text-center col-md-3">
                                      Remaining
                                  </th>
                                  <th class="no-border text-center col-md-3">
                                      Payment
                                  </th>
                                  <th class="no-border col-md-2">
                                      <button :disabled="amount <= 0 && debtor_id"
                                              class="btn btn-primary"
                                              @click="distributeToSelected()"
                                              onclick="return false;">
                                          Distribute To Selected
                                      </button>
                                  </th>
                                  <th class="no-border col-md-2">
                                      <button :disabled="amount <= 0 && debtor_id"
                                              class="btn btn-primary"
                                              @click="distribute()"
                                              onclick="return false;">
                                          Distribute Amount
                                      </button>
                                  </th>
                              </tr>
                          </thead>
                          <tbody style="border: 1px solid rgba(221, 221, 221, 1);">
                              <tr v-for="(payment, key) in expensePayments">
                                  <td class="text-center">
                                      {{ payment.expenseName }}
                                  </td>

                                  <td>
                                      <input class="form-control text-right"
                                             v-model="payment.amountOfExpense"
                                             readOnly
                                             number
                                             data-type="currency" />
                                  </td>
                                  <td>
                                      <input class="form-control text-right"
                                             :value="
                          parseFloat(
                            payment.amountOfExpense -
                              payment.amountPaid -
                              (payment.payment == undefined ? 0 : payment.payment)
                          ) | toCurrency 
                        "
                                             readOnly
                                             number
                                             data-type="currency" />
                                  </td>

                                  <td>
                                      <input :min="0"
                                             :max="payment.amountOfExpense - payment.amountPaid"
                                             class="form-control text-right"
                                             v-model="payment.payment"
                                             number
                                             data-type="currency" />
                                  </td>
                                  <td class="text-center">
                                      <input type="checkbox" v-model="payment.isSelected" />
                                  </td>
                                  <td></td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 text-center">
                  <div class="text-center">
                      <button type="submit" @click="save()" class="btn btn-submit" style="margin: 15px;">
                          Submit
                      </button>
                      <button @click="closeModal()" class="btn btn-cancel">Cancel</button>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
export default {
  props: ["buildingId", "debtorId", "monthProp"],
  data: function () {
    return {
      payment: {},
      monthlyFees: [],
      debtors: [],
      building: {},
      building_id: 0,
      payment_type: 0,
      reference: "",
      month: 0,
      debtor_id: 0,
      paid_date: null,
      date: "2016-10-16",
      additionalExpensePayment: [],
      expensePayments: [],
      errors: [],
      expenseTypes: [],
      amount: undefined,
    };
  },

  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      this.fetchProperty();
    },
  },

  mounted() {
    this.building_id = this.buildingId;
    if (this.buildingId) this.fetchProperty();
  },

  methods: {
    paymentTypeChange(paymentType) {
      if (paymentType == 1) {
        this.additionalExpensePayment.bank = "";
        this.additionalExpensePayment.reference = "";
      }
    },
    fetchProperty: async function () {
      var request = "/payments/providers";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.debtors = data.properties;
          this.expenseTypes = data.expenseTypes;
        });
    },

    customFormatter(date) {
      //alert(moment(date).format('dd/MM/YYYY'));
      //return date | moment("dddd, MMMM Do YYYY")
      return format(date, "dd/MM/yyyy");
    },

    onChange: async function () {
      var self = this;

      var request = "/payments/debtor";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.debtor_id;
      this.$http
        .get(request, {
          id: this.debtor_id,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.additionalExpensePayment = data.additionalExpensePayment;
            this.expensePayments = data.expensePayments;
            for (var i = 0; i < this.expensePayments.length; i++)
                this.expensePayments[i].payment = undefined
        });
    },

    distributeToSelected: function () {
      try {
        var amount = this.amount;

        for (var i = 0; i < this.expensePayments.length; i++) {
          if (this.expensePayments[i].isSelected) {
            if (amount == 0) break;
            var remainingAmount =
              this.expensePayments[i].amountOfExpense -
              this.expensePayments[i].amountPaid -
                (this.expensePayments[i].payment == undefined ? 0 : this.expensePayments[i].payment);

            if (amount >= remainingAmount) {
              this.expensePayments[i].payment = remainingAmount;
                console.log(this.expensePayments[i].payment == undefined ? 0 : this.expensePayments[i].payment);
              amount = amount - remainingAmount;
            } else {
              this.expensePayments[i].payment = amount;
                console.log(this.expensePayments[i].payment == undefined ? 0 : this.expensePayments[i].payment);
              amount = 0;
            }
          } else {
            this.expensePayments[i].payment = 0;
            console.log(this.expensePayments[i].payment);
          }
        }
      } catch (e) {
        alert(e);
      }
    },

    distribute: function () {
      try {
        var amount = this.amount;

        for (var i = 0; i < this.expensePayments.length; i++) {
          if (amount == 0) break;
          var remainingAmount =
            this.expensePayments[i].amountOfExpense -
            this.expensePayments[i].amountPaid -
              (this.expensePayments[i].payment == undefined ? 0 : this.expensePayments[i].payment);
          if (amount >= remainingAmount) {
            this.expensePayments[i].payment = parseFloat(remainingAmount);
            //alert(this.expensePayments[i].payment )
            console.log(this.expensePayments[i].payment);
            amount = amount - remainingAmount;
          } else {
            this.expensePayments[i].payment = parseFloat(amount);
            console.log(this.expensePayments[i].payment);
            //alert(this.expensePayments[i].payment )
            amount = 0;
          }
        }
      } catch (e) {
        alert(e);
      }
    },

    closeModal: function () {
        this.$modal.hide("control-panel-add-form");
    },
    checkForm: function (e) {
      this.errors = [];

      if (!this.debtor_id) {
        this.errors.push("Please select debtor.");
      }

      if (!this.additionalExpensePayment.paymentType) {
        this.errors.push("Please enter payment type.");
      }

      if (!this.additionalExpensePayment.paidDate) {
        this.errors.push("Please enter paid date.");
      }

      for (var i = 0; i < this.expensePayments.length; i++) {
          var allocatedAmount = parseFloat(this.expensePayments[i].payment == undefined ? 0 : this.expensePayments[i].payment);
        var remainingAmount = parseFloat(
          this.expensePayments[i].amountofexpense -
            this.expensePayments[i].amountpaid
        );
        if (allocatedAmount > remainingAmount)
          this.errors.push(
            "Payment amount greater than remaining expense amount."
          );
      }

      if (this.errors.length == 0) return;

      e.preventDefault();
    },
    save() {
      this.checkForm();
      this.$http
        .post("/payments/additional", {
          propertyId: this.debtor_id,
          expensePaymentFees: this.expensePayments,
          additionalExpensePayment: this.additionalExpensePayment,
        })
        .then(
          () => {
            this.closeModal();
            location.reload();
            this.$router.push({
              name: "controlpanel",
              params: { buildingId: this.buildingId },
            });
          },
          () => {
            alert("error");
            //  this.infoError = true
            //  this.loader = false
            //   this.password = ''
          }
        );
    },
  },

  computed: {},
};
</script>
